import { useMemo } from "react";

import clsx from "clsx";

import { DocumentList } from "@/features/documents";

// import { AssignCreator } from "features/creators";

export const CampaignDocuments = ({ campaign_id, className, ...props }) => {
  const classes = clsx("campaign-documents", className);
  const filterParams = useMemo(() => {
    return {
      campaign_id,
    };
  }, [campaign_id]);
  return (
    <DocumentList
      filterParams={filterParams}
      campaignId={campaign_id}
      className={classes}
      gridId="campaign-documents"
      excludeDataSources={"campaign"}
    />
  );
};
